import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { FullPageSpinnerPortal } from '@/components/common/Spinner/FullPagePortal'
import { UserDashboardPage } from '@/components/pages/Dashboard/UserDashboardPage'
import { getApiAuthMeOptions } from '@/lib/api/client/@tanstack/react-query.gen'

export const Route = createFileRoute('/_liff/_dashboard/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { data, isLoading } = useQuery(getApiAuthMeOptions())

  if (isLoading) {
    return <FullPageSpinnerPortal />
  }

  return <UserDashboardPage />
}
